<template>
    <div>
        <div class="chart-header">
            <slot name="chart-header"></slot>
        </div>
        <div class="chart-body">
            <slot name="chart-body"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ChartContainer'
}
</script>

<style scoped>
.chart-body {
    height: 100%;
}
</style>
